/* stylelint-disable */
:host {
  display: block;
}

.product-information {
  font-weight: normal;
}

@media screen and (min-width: 980px) {
  .product-information {
    font-size: 14px;
    line-height: 1.4285714286;
    border: 0;
  }

  :host(:not([dir="rtl"])) .product-information {
    margin: 26px 0 0 20px;
  }

  :host([dir="rtl"]) .product-information {
    margin: 26px 20px 0 0;
  }
}

.product-information a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.product-information a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.product-information a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.product-information a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.product-information a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.product-information a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.product-information a[rel~=external] > .qds-external {
  display: inline-block;
}

.product-information a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.product-information a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

@media screen and (max-width: 979px) {
  .product-information > *:first-child {
    border-top: 1px solid #9fa0a4;
  }
}

.product-information .text {
  display: inline-block;
  width: 100%;
  margin: 20px 0 0;
  padding-top: 1px;
}

.product-information .text:last-child {
  margin-bottom: 20px;
}

.product-information h3 {
  font-size: 30px;
  margin-bottom: 15px;
}

.product-information span {
  font-size: 15px;
  line-height: 1.3333333333;
  display: block;
  color: #000000;
  font-weight: bold;
}

.richText span {
  font-weight: normal;
}

.product-information table {
  width: 100%;
}

.product-information table tr {
  border-bottom: 1px solid #e7e6e6;
  border-bottom: 0;
}

.product-information table tr:last-child {
  border-bottom: none;
}

.product-information table tr td {
  vertical-align: top;
  color: #333333;
}

:host(:not([dir="rtl"])) .product-information table tr td {
  padding: 10px 10px 10px 0;
}

:host([dir="rtl"]) .product-information table tr td {
  padding: 10px 0 10px 10px;
}

.product-information table tr td:first-child {
  font-weight: bold;
}

@media screen and (min-width: 980px) {
  .product-information table tr td:first-child {
    width: 35%;
  }
}

@media screen and (max-width: 979px) {
  .product-information table tr td,
.product-information table tr td:first-child {
    padding: 0;
  }
}